import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import { TalentPoolEventRs } from '@domain/rs/event/TalentPoolEventRs';
import EventParticipationStatusRs from '@domain/rs/event/EventParticipationStatusRs';
import { EventDateRs } from '@domain/rs/event/EventDateRs';
import { EventType } from '@domain/constant/event/EventType';

export default interface EventRepo {
  //찐BTI 이벤트 응모하기
  fetchEventsAccMbtiApply(): Promise<AxiosResponse>;

  //역량검사 응시 이벤트 응모(인재풀 이벤트)
  fetchEventsTalentPoolAccaTestApply(): Promise<AxiosResponse>;

  //프로필/역량검사 완료 이벤트 응모(인재풀 이벤트)
  fetchEventsTalentPoolFinalApply(): Promise<AxiosResponse>;

  //프로필 입력 이벤트 응모(인재풀 이벤트)
  fetchEventsTalentPoolProfileApply(): Promise<AxiosResponse>;

  //유저 상태 조회(인재풀 이벤트)
  fetchEventsTalentPoolUserStatus(): Promise<AxiosResponse>;

  //역량검사 이벤트 (직무별 합격자 이력서 모음.ZIP) 받기
  fetchDownloadTalentPoolResume(): Promise<AxiosResponse>;

  //{* 추석 이벤트 }
  // 이벤트 응모 여부 확인
  fetchEventsParticipationStatus(eventType: EventType): Promise<AxiosResponse<EventParticipationStatusRs>>;

  //추석 인재풀 이벤트 응모하기
  fetchEventsHolidayApply(): Promise<AxiosResponse>;

  //(합격자 이력서 모음)받기
  fetchEventsProfileDownload(): Promise<AxiosResponse>;

  // 매칭 이벤트 응모하기
  fetchEventsMatchingApply(url: string): Promise<AxiosResponse>;

  // 프로필 완성 이벤트
  fetchEventProfileApply(): Promise<AxiosResponse>;

  //jbti 유저수 조회
  fetchJbtiUsers(): Promise<AxiosResponse<{ jbtiUserCount: number }>>;

  //이벤트 날짜 변경
  fetchEventDate(eventType: EventType): Promise<AxiosResponse<EventDateRs>>;
}

export class RemoteEventRepo implements EventRepo {
  fetchEventsAccMbtiApply(): Promise<AxiosResponse> {
    return axios.post('/events/acc/mbti/apply');
  }

  fetchEventsTalentPoolAccaTestApply(): Promise<AxiosResponse> {
    return axios.post('/events/talent-pool/acc-test/apply');
  }

  fetchEventsTalentPoolFinalApply(): Promise<AxiosResponse> {
    return axios.post('/events/talent-pool/final/apply');
  }

  fetchEventsTalentPoolProfileApply(): Promise<AxiosResponse> {
    return axios.post('/events/talent-pool/profile-input/apply');
  }

  fetchEventsTalentPoolUserStatus(): Promise<AxiosResponse<TalentPoolEventRs>> {
    return axios.get<TalentPoolEventRs>('/events/talent-pool/user-status');
  }

  fetchDownloadTalentPoolResume(): Promise<AxiosResponse> {
    return axios.get<ArrayBuffer>('/events/talent-pool/acc-test/resume-download', { responseType: 'arraybuffer' });
  }

  fetchEventsParticipationStatus(eventType: EventType): Promise<AxiosResponse<EventParticipationStatusRs>> {
    return axios.get<EventParticipationStatusRs>(`/events/participation-status`, { params: { eventType } });
  }

  fetchEventsHolidayApply(): Promise<AxiosResponse> {
    return axios.post('/events/talent-pool/holiday-2023/apply');
  }

  fetchEventsProfileDownload(): Promise<AxiosResponse> {
    return axios.get<ArrayBuffer>('/events/profile-complete-2024/profile-download', { responseType: 'arraybuffer' });
  }

  fetchEventsMatchingApply(url: string): Promise<AxiosResponse> {
    return axios.post('/events/matching/apply', { url });
  }

  fetchEventProfileApply(): Promise<AxiosResponse> {
    return axios.post('/events/profile/apply');
  }

  fetchJbtiUsers(): Promise<AxiosResponse<{ jbtiUserCount: number }>> {
    return axios.get<{ jbtiUserCount: number }>('https://api.acca.jobda.im/jbti_users');
  }

  fetchEventDate(eventType: EventType): Promise<AxiosResponse<EventDateRs>> {
    return axios.get('/events', { params: { eventType } });
  }
}
